import React from 'react';
import PropTypes from 'prop-types';
import { Card, SmallText } from '../../../legacy/hui/src/styled/';
import styled from 'styled-components';

const ShadowCard = Card.extend`
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  min-width: 300px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    min-width: 380px;
  }
`;

const Thumbnail = styled.img`
  height: 58px;
  width: 83px;
  background-color: #aaa;
  border-radius: 10px;
  margin-right: 0.7rem;
  border: 1px solid #efefef;
  @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
    height: 60px;
    width: 86px;
  }
`;

const TradieDetails = styled(Card.Section)`
  display: flex;
  padding: 1rem 0 1rem 1rem;
  position: relative;
`;

const ThumbnailWrapper = styled.a`
  flex-basis: 95px;
  flex-shrink: 0;
  flex-grow: 0;
  @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
    flex-basis: 100px;
  }
`;

export class TradieCard extends React.Component {
  static propTypes = {
    connection: PropTypes.object
  };

  render() {
    const { connection } = this.props;
    const { siteName, numberOfRecommendations, phone, mobile, thumbnail } = connection;
    const displayPhone = mobile || phone;

    return (
      <ShadowCard snow p={0} mt={1}>
        <TradieDetails>
          <ThumbnailWrapper>
            <Thumbnail src={thumbnail} />
          </ThumbnailWrapper>
          <div style={{ flexGrow: 1 }}>
            <div style={{ marginBottom: '0.3rem', fontWeight: '600' }}>{siteName}</div>
            {numberOfRecommendations > 0 && (
              <SmallText m={0}>
                {numberOfRecommendations} Recommendation{numberOfRecommendations > 1 ? 's' : ''}
              </SmallText>
            )}
            {displayPhone && (
              <SmallText m={0}>
                <a href={`tel:${displayPhone.replace(/ /g, '')}`}>{displayPhone}</a>
              </SmallText>
            )}
          </div>
        </TradieDetails>
      </ShadowCard>
    );
  }
}

export default TradieCard;
